export type DescriptionTab = 'proposal' | 'invoice'

export type DescriptionOwner = 'workarea' | 'groupedWorkarea' | 'group'

export const getProposalDescriptionHelp = (owner: DescriptionOwner): string => {
  switch (owner) {
    case 'workarea':
      return 'Provide a summary of your work area that will be shown on the customer proposal.'
    case 'groupedWorkarea':
      return 'This work area belongs to a group, so the group description is what appears on the proposal. Edit it on the group to change what the customer sees.'
    case 'group':
      return 'Provide a summary of your work area group that will be shown on the customer proposal.'
  }
}

export const getInvoiceDescriptionHelp = (owner: DescriptionOwner): string => {
  switch (owner) {
    case 'workarea':
      return 'The description new invoices for this work area start with. If it is empty, invoices use the proposal description.'
    case 'groupedWorkarea':
      return 'This work area belongs to a group, so the group invoice description is what invoices use. Edit it on the group to change what the customer sees. If the group invoice description is empty, invoices use the group proposal description.'
    case 'group':
      return 'The description new invoices for this work area group start with. If it is empty, invoices use the proposal description.'
  }
}
